import React, { useEffect, useState, useRef } from 'react';
import {
  PlayCircleOutlined,
  StopOutlined,
  RedoOutlined,
  RocketOutlined,
  RightOutlined,
  LeftOutlined,
  UndoOutlined,
  PauseOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import {
  Play,
  CircleStopIcon as Stop,
  RotateCcw,
  Rocket,
  ArrowLeft,
  ArrowRight,
  Upload,
  UploadCloud,
  ChevronLeft,
  ChevronRight,
} from 'lucide-react';
// import FileLoaderService from 'platform/viewer/src/routes/Local/fileLoaderService';
import FileLoaderService from '../../../../../../../platform/viewer/src/routes/Local/fileLoaderService';
import {
  BlindSweep as BlindSweepProps,
  BlindSweepMode,
  Sweep as SweepItems,
  UploaderType,
} from '../../interfaces';
import Sweep from '../../Components/SweepItems/SweepItems';
import PatientTableSelectionRealtime from '../../Components/select-patient';
import PixelComponent from '../../Components/new-pixel-component';
import ChooseRecordMode from '../../Components/ChoseRecordMode/chose-record-mode';
import BlindSweepPatient from '../../Components/BlindSweepPatient/BlindSweepPatient';
import BlindSweepPixelSpacing from '../../Components/BlindSweepPixelSpacing/BlindSweepPixelSpacing';
import { useNavigate } from 'react-router';
import { useCreateBlindStudy } from '../../../helpers/api/studies/studies';

function BlindSweep() {
  // Step management
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [recordMode, setRecordMode] = useState<'UPLOADER' | 'RECORDER' | null>(
    null
  );
  const [fileType, setFileType] = useState<'video' | 'dicom' | null>(null);
  const [selectedRow, setSelectedRow] = useState<any>();
  const [showPatientModal, setShowPatientModal] = useState<boolean>(false);
  const [showDeviceModal, setShowDeviceModal] = useState<boolean>(false);
  const [globalState, setGlobalState] = useState<any>({});
  const navigate = useNavigate();
  const onSuccess = (response: any, data: any) => {
    if (response?.status_code === 200) {
      navigate(
        `/sweep/viewer?StudyInstanceUIDs=${response?.data?.result?.study_instance_uid}`
      );
    }
  };

  const onError = (error: any, data: any) => {
    console.log('srReport:', error, data);
  };
  const { mutate: createBlindStudy, isPending: createBlindStudyLoading } =
    useCreateBlindStudy(onSuccess, onError);

  function handleModeSelect(mode: 'UPLOADER' | 'RECORDER') {
    setRecordMode(mode);
  }

  function handleNext(data: {
    mode: 'UPLOADER' | 'RECORDER';
    fileType?: 'video' | 'dicom';
  }) {
    setRecordMode(data.mode);
    if (data.fileType) {
      setFileType(data.fileType);
    }
    goToNextStep();
  }

  function handlePatientSelection() {
    console.log('BlindSweep:', {
      patient_id: selectedRow?.patient?.id,
      study_mode: recordMode,
    });
    createBlindStudy({
      patient_id: selectedRow?.patient?.id,
      study_mode: recordMode,
    });
    // navigate(`/sweep/8565613126843213543`);
  }

  function goToNextStep() {
    setCurrentStep((prev) => prev + 1);
  }

  function goToPreviousStep() {
    setCurrentStep((prev) => Math.max(0, prev - 1));
  }

  const maxSteps = recordMode === 'RECORDER' ? 3 : 2;
  console.log('selectedRow ::', selectedRow);
  // Render the current step
  // const renderCurrentStep = () => {
  //   switch (currentStep) {
  //     case 0:
  //       return (
  //         <ChooseRecordMode
  //           onModeSelect={handleModeSelect}
  //           onNext={handleNext}
  //         />
  //       );
  //     case 1:
  //       // if (recordMode === 'RECORDER') {
  //       //   return (
  //       //     <BlindSweepPixelSpacing
  //       //       setGlobalState={setGlobalState}
  //       //       globalState={globalState}
  //       //       setShowDeviceModal={setShowDeviceModal}
  //       //       onNext={goToNextStep}
  //       //       onPrevious={goToPreviousStep}
  //       //     />
  //       //   );
  //       // } else {
  //         return (
  //           <BlindSweepPatient
  //             handlePatientSelection={handlePatientSelection}
  //             showPatientModal={true}
  //             setShowPatientModal={setShowPatientModal}
  //             selectedRow={selectedRow}
  //             setSelectedRow={setSelectedRow}
  //             onNext={goToNextStep}
  //             onPrevious={goToPreviousStep} />
  //         );
  //       // }
  //     case 2:
  //       if (recordMode === 'RECORDER') {
  //         return (
  //           <BlindSweepPatient
  //             handlePatientSelection={handlePatientSelection}
  //             showPatientModal={true}
  //             setShowPatientModal={setShowPatientModal}
  //             selectedRow={selectedRow}
  //             setSelectedRow={setSelectedRow}
  //             onNext={goToNextStep}
  //             onPrevious={goToPreviousStep} />
  //         );
  //       } else {
  //         return (
  //           <Sweep
  //             sweeps={sweeps}
  //             setSweeps={setSweeps}
  //             mode={BlindSweepMode.UPLOAD}
  //             uploader={fileType === 'dicom' ? UploaderType.DICOM : UploaderType.VIDEO}
  //             onPrevious={goToPreviousStep}
  //             showNavigation={true}
  //           />
  //         );
  //       }
  //     case 3:
  //       return (
  //         <Sweep
  //           sweeps={sweeps}
  //           setSweeps={setSweeps}
  //           mode={BlindSweepMode.RECORD}
  //           uploader={UploaderType.VIDEO}
  //           onPrevious={goToPreviousStep}
  //           showNavigation={true}
  //         />
  //       );
  //     default:
  //       return null;
  //   }
  // };
  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <ChooseRecordMode
            onModeSelect={handleModeSelect}
            onNext={handleNext}
          />
        );
      case 1:
        return (
          <BlindSweepPatient
            setShowPatientModal={setShowPatientModal}
            createBlindStudyLoading={createBlindStudyLoading}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            onNext={handlePatientSelection}
            onPrevious={goToPreviousStep}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full h-full flex flex-col">{renderCurrentStep()}</div>
  );
}

export default BlindSweep;
